module.exports = __webpack_public_path__ + "img/empty-collection.792d763a.png";